import axios from 'axios';
import { createURLSearchParams } from '../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../common/customAxios';

export interface ICropFavoriteInfo {
  id: string;
  categorySmall: {
    id: string;
    name: string;
    externalCode: string;
    categoryMiddle: {
      id: string;
      name: string;
      externalCode: string;
      categoryLarge: {
        id: string;
        name: string;
        externalCode: string;
      };
    };
  };
  agriMarket: {
    id: string;
    name: string;
    externalCode: string;
  };
}

export const getCropFavorite = (): Promise<ICropFavoriteInfo[]> => {
  return customAxios.get(`/crops/favorites`);
};
